import React from 'react';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import CustomerSupportNavBar from '../../../../layouts/customer-support/CustomerSupportNavBar';
import CustomerSupportScheduleBody from './CustomerSupportScheduleBody';

const BusinessDevelopmentBasestationStatus = () => {
  const { profile } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <CustomerSupportNavBar currentPage="Schedule" position={firstName} />
        <CustomerSupportScheduleBody />
      </main>
    </div>
  );
};

export default BusinessDevelopmentBasestationStatus;
